import Vue from 'vue'
import Vuex from 'vuex'
import errorLog from './modules/errorLog'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import systemConfig from './modules/config'
import getters from './getters'
import app from './modules/app'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    errorLog,
    permission,
    tagsView,
    user,
    systemConfig
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js